import Api from '@/services/Api'

const URL = 'cxc/caja/';
const ACCION_AGREGAR_LOTE = 'agregar_producto_lote';

export default {

    fetch(params) {
        return Api().get(URL,{
            params: params
        })
    },
    getById(id) {
        return Api().get(URL + id)
    },
    save(params) {
        let url = URL;
        if ('id' in params) {
            return Api().put(url + params.id + '/', params)
        }
        return Api().post(url, params)
    },
    agregar_producto_lote(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACCION_AGREGAR_LOTE}/`, params);

    },
}